import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Switch,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';

const medicalCenters = ['ForMyers',
  'FortPierce',
  'Immokalee',
  'LakeWorth',
  'Lehigh',
  'Naples',
  'PortSaintLucie'];

const SpecialistReferralFormCodOpp = ({ modificar = {}, onSave, isDisabled = false }) => {
  const [notesSigned, setNotesSigned] = useState(modificar.WereNotesSingned || false);
  const [chargeSlip, setChargeSlip] = useState(modificar.Waschargeslipcompleted || false);

  const [serviceDate, setServiceDate] = useState(
    modificar.ServiceDate ? dayjs(modificar.ServiceDate, 'MM/DD/YYYY') : null
  );

  function numeroAleatorio20a10000() {
    return Math.floor(Math.random() * (10000 - 20 + 1)) + 20;
  }

  const [form, setForm] = useState({
    id: modificar.id || numeroAleatorio20a10000(),
    PatientName: modificar.PatientName || '',
    ServiceDate: modificar.ServiceDate || '',
    ProviderName: modificar.ProviderName || '',
    WereNotesSigned: modificar.WereNotesSigned || false,
    WasChargeSlipComleted: modificar.WasChargeSlipComleted || false,
    Name: modificar.Name || '',
    TimeStamp: modificar.TimeStamp || '',
    MedicalCenter: modificar.MedicalCenter || ''
  });
  

  const handleSave = () => {
    const UpdateData = form;
    UpdateData.ServiceDate = serviceDate;
    onSave(UpdateData);
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };
  
  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">CHARGE SLIP FORM</Typography>
          <Button variant="contained" startIcon={<EditIcon />} onClick={handleSave}>Save</Button>
      </Box>

      {/* Member Info */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Patient Name:</strong> </Typography></Grid>
          <TextField
            fullWidth
            value={form.PatientName}
            onChange={e => handleChange('PatientName', e.target.value)}
          />
          
          <Grid item width="100%"><Typography><strong>Service Date:</strong> </Typography></Grid>
          <Grid item width="100%" >
            <DatePicker
              value={serviceDate}
              onChange={(newValue) => setServiceDate(newValue)}
              format="MM/DD/YYYY"
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>
          <Grid item width="100%"><Typography><strong>Provider:</strong> </Typography></Grid>
          <TextField
            fullWidth
            value={form.ProviderName}
            onChange={e => handleChange('ProviderName', e.target.value)}
          />
          <Grid item width="100%" >
            <Typography>Were notes signed?</Typography>
            <Switch checked={notesSigned} onChange={(e) => setNotesSigned(e.target.checked)} />
          </Grid>
          <Grid item width="100%">
            <Typography>Was charge slip completed?</Typography>
            <Switch checked={chargeSlip} onChange={(e) => setChargeSlip(e.target.checked)} />
          </Grid>
          <Grid item width="100%"><Typography><strong>Medical Center:</strong></Typography></Grid>
          <TextField
            select
            fullWidth
            value={form.MedicalCenter}
            onChange={e => handleChange('MedicalCenter', e.target.value)}
          >
            {medicalCenters.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Grid item width="100%"><Typography><strong>Timestamp:</strong></Typography></Grid>
          <TextField
            fullWidth
            value={form.TimeStamp}
            disabled
          />
        </Grid>
      </Paper>
    </Container>
  );
};

export default SpecialistReferralFormCodOpp;
